export default {
  ProfileIcon: require('../assets/images/ProfileIcon.png'),
  DyAppLogo: require('../assets/images/DyAppLogo.png'),
  DyAppLoginLogo: require('../assets/images/DyAppLoginLogo.png'),
  WatchedIcon: require('../assets/images/WatchedIcon.png'),
  Time: require('../assets/images/Time.png'),
  BxStopwatch1: require('../assets/images/BxStopwatch1.png'),
  BxVideoRecording1: require('../assets/images/BxVideoRecording1.png'),
};
